import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import Navbar from "../navigation/Navbar";
import { mainGet } from "../../domain/net/mainApi";
/* eslint-disable react-hooks/exhaustive-deps */

// Компонент загрузки
const Loader = () => (
    <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f8fafc'
    }}>
        <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #e5e7eb',
            borderTop: '4px solid #3b82f6',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
        }} />
        <style>
            {`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}
        </style>
    </div>
);

// Компонент карточки профиля
const ProfileCard = ({ children, title }) => (
    <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '24px',
        marginBottom: '20px',
        border: '1px solid #e1e5e9',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        width: '100%'
    }}>
        {title && (
            <h2 style={{
                fontSize: '20px',
                fontWeight: '600',
                color: '#1a1a1a',
                margin: '0 0 20px 0',
                textAlign: 'center'
            }}>
                {title}
            </h2>
        )}
        {children}
    </div>
);

// Компонент поля ввода
const InputField = ({ label, value, onChange, disabled, type = "text", placeholder }) => (
    <div style={{ marginBottom: '16px' }}>
        <label style={{
            display: 'block',
            fontSize: '14px',
            fontWeight: '500',
            color: '#6b7280',
            marginBottom: '6px'
        }}>
            {label}
        </label>
        {type === "textarea" ? (
            <textarea
                value={value || ''}
                onChange={onChange}
                disabled={disabled}
                placeholder={placeholder}
                style={{
                    width: '100%',
                    padding: '12px',
                    border: '1px solid #e1e5e9',
                    borderRadius: '8px',
                    fontSize: '14px',
                    fontFamily: 'inherit',
                    resize: 'vertical',
                    minHeight: '80px',
                    backgroundColor: disabled ? '#f9fafb' : 'white',
                    color: disabled ? '#6b7280' : '#1a1a1a',
                    outline: 'none',
                    transition: 'border-color 0.2s ease'
                }}
                onFocus={(e) => !disabled && (e.target.style.borderColor = '#3b82f6')}
                onBlur={(e) => !disabled && (e.target.style.borderColor = '#e1e5e9')}
            />
        ) : (
            <input
                type={type}
                value={value || ''}
                onChange={onChange}
                disabled={disabled}
                placeholder={placeholder}
                style={{
                    width: '100%',
                    padding: '12px',
                    border: '1px solid #e1e5e9',
                    borderRadius: '8px',
                    fontSize: '14px',
                    backgroundColor: disabled ? '#f9fafb' : 'white',
                    color: disabled ? '#6b7280' : '#1a1a1a',
                    outline: 'none',
                    transition: 'border-color 0.2s ease'
                }}
                onFocus={(e) => !disabled && (e.target.style.borderColor = '#3b82f6')}
                onBlur={(e) => !disabled && (e.target.style.borderColor = '#e1e5e9')}
            />
        )}
    </div>
);

// Компонент кнопки
const Button = ({ children, onClick, variant = 'primary', disabled, ...props }) => {
    const baseStyle = {
        padding: '12px 24px',
        border: 'none',
        borderRadius: '8px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        fontSize: '14px',
        fontWeight: '500',
        transition: 'all 0.2s ease',
        opacity: disabled ? 0.6 : 1
    };

    const variants = {
        primary: {
            backgroundColor: '#3b82f6',
            color: 'white',
            hoverColor: '#2563eb'
        },
        secondary: {
            backgroundColor: '#6b7280',
            color: 'white',
            hoverColor: '#4b5563'
        }
    };

    const style = {
        ...baseStyle,
        backgroundColor: variants[variant].backgroundColor,
        color: variants[variant].color,
        ...props.style
    };

    return (
        <button
            onClick={disabled ? undefined : onClick}
            style={style}
            onMouseOver={(e) => !disabled && (e.target.style.backgroundColor = variants[variant].hoverColor)}
            onMouseOut={(e) => !disabled && (e.target.style.backgroundColor = variants[variant].backgroundColor)}
            {...props}
        >
            {children}
        </button>
    );
};

export default function Account() {
    let P = useParams();
    const [user, setUser] = useState({});
    const [Prole, setProle] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    const getProfileData = () => {
        let clid = P.clid;
        setIsLoading(true);

        mainGet({
            type: 'preloadPage',
            id: clid,
            whom: localStorage.getItem('clid')
        })
            .then(rs => {
                if (rs.data.ok) {
                    setUser(JSON.parse(rs.data.user));
                    setProle(rs.data.parent_role);
                } else {
                    console.error('Ошибка загрузки профиля:', rs.data);
                }
            })
            .catch(error => {
                console.error('Ошибка сети:', error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const updateUser = () => {
        mainGet({
            type: 'updUser',
            public_key: user.public_key,
            parentChange: user.fixed_trainer,
            email: user.email,
            phone: user.phone,
            s_phone: user.s_phone,
            city: user.city,
            trainig_place: user.trainig_place,
            bday: user.bday,
            about: user.about,
            byt: user.byt
        })
            .then(res => {
                if (res.data.ok) {
                    window.location.reload();
                } else {
                    alert('Произошла ошибка при сохранении');
                }
            })
            .catch(error => {
                console.error('Ошибка обновления:', error);
                alert('Произошла ошибка при сохранении');
            });
    };

    const handleInputChange = (field) => (e) => {
        setUser(prev => ({ ...prev, [field]: e.target.value }));
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        getProfileData();
    }, [P.clid]);

    if (isLoading || !user.name) {
        return <Loader />;
    }

    const isStudent = user.role === 'student';
    const isViewOnly = Prole === 'student';
    const canEdit = !isViewOnly;

    const backgroundStyle = {
        minHeight: '100vh',
        padding: '20px 16px 80px 16px',
        backgroundImage: `url(${require('../../media/backgrounds/bg-2.png')})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        backgroundRepeat: 'no-repeat',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    };

    return (
        <div style={backgroundStyle}>
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                zIndex: -1
            }} />

            <Helmet>
                <title>{user.name} {user.sname}</title>
                <link rel="shortcut icon" href="/favicon.ico" />
            </Helmet>

            <div style={{ maxWidth: '600px', margin: '0 auto', position: 'relative' }}>
                {/* Заголовок страницы */}
                <div style={{
                    textAlign: 'center',
                    marginBottom: '32px',
                    padding: '0 16px'
                }}>
                    <h1 style={{
                        fontSize: '28px',
                        fontWeight: '700',
                        color: '#1a1a1a',
                        margin: '0 0 8px 0'
                    }}>
                        Профиль
                    </h1>
                    <p style={{
                        color: '#6b7280',
                        fontSize: '16px',
                        margin: 0
                    }}>
                        {isStudent ? 'Ученица' : user.role === 'admin' ? 'Администратор' : 'Тренер'}
                    </p>
                </div>

                {/* Кнопка сохранения */}
                {canEdit && (
                    <div style={{
                        textAlign: 'right',
                        marginBottom: '20px',
                        padding: '0 16px'
                    }}>
                        <Button onClick={updateUser}>
                            Сохранить изменения
                        </Button>
                    </div>
                )}

                {/* Основная информация */}
                <ProfileCard title="Основная информация">
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        marginBottom: '20px',
                        paddingBottom: '20px',
                        borderBottom: '1px solid #f1f5f9'
                    }}>
                        <div style={{
                            width: '80px',
                            height: '80px',
                            borderRadius: '50%',
                            backgroundColor: '#3b82f6',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '24px',
                            fontWeight: '600',
                            color: 'white',
                            flexShrink: 0
                        }}>
                            {user.name?.[0]}{user.sname?.[0]}
                        </div>
                        <div style={{ flex: 1 }}>
                            <h1 style={{
                                fontSize: '24px',
                                fontWeight: '700',
                                color: '#1a1a1a',
                                margin: '0 0 4px 0'
                            }}>
                                {user.sname} {user.name} {user.ots && user.ots}
                            </h1>
                            <p style={{
                                fontSize: '14px',
                                color: '#6b7280',
                                margin: 0
                            }}>
                                ID: {user.public_key}
                            </p>
                            {isStudent && user.fixed_trainer && user.fixed_trainer !== '-' && (
                                <p style={{
                                    fontSize: '14px',
                                    color: '#6b7280',
                                    margin: '4px 0 0 0'
                                }}>
                                    ID тренера: {user.fixed_trainer}
                                </p>
                            )}
                            <p style={{
                                fontSize: '14px',
                                color: '#6b7280',
                                margin: '4px 0 0 0'
                            }}>
                                Дата регистрации: {user.date_reg}
                            </p>
                        </div>
                    </div>

                    <div style={{ display: 'grid', gap: '16px' }}>
                        <InputField
                            label="Email"
                            value={user.email}
                            onChange={handleInputChange('email')}
                            disabled={isViewOnly}
                            type="email"
                            placeholder="Введите email"
                        />

                        <InputField
                            label="Телефон"
                            value={user.phone}
                            onChange={handleInputChange('phone')}
                            disabled={isViewOnly}
                            type="tel"
                            placeholder="Введите телефон"
                        />

                        {isStudent && (
                            <InputField
                                label="Телефон родителей"
                                value={user.s_phone}
                                onChange={handleInputChange('s_phone')}
                                disabled={isViewOnly}
                                type="tel"
                                placeholder="Введите телефон родителей"
                            />
                        )}

                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                            <InputField
                                label="Город"
                                value={user.city}
                                onChange={handleInputChange('city')}
                                disabled={isViewOnly}
                                placeholder="Введите город"
                            />

                            <InputField
                                label="Дата рождения"
                                value={user.bday}
                                onChange={handleInputChange('bday')}
                                disabled={isViewOnly}
                                placeholder="ДД.ММ.ГГГГ"
                            />
                        </div>

                        <InputField
                            label="Место тренировок"
                            value={user.trainig_place}
                            onChange={handleInputChange('trainig_place')}
                            disabled={isViewOnly}
                            placeholder="Введите место тренировок"
                        />
                    </div>
                </ProfileCard>

                {/* О себе / Об ученице */}
                <ProfileCard title={isStudent ? 'Об ученице' : 'О себе'}>
                    <InputField
                        label={isStudent ? 'Информация об ученице' : 'Информация о себе'}
                        value={user.about}
                        onChange={handleInputChange('about')}
                        disabled={isViewOnly}
                        type="textarea"
                        placeholder={isStudent ? 'Расскажите об ученице...' : 'Расскажите о себе...'}
                    />
                </ProfileCard>

                {/* Характеристика от тренера (только для студентов) */}
                {isStudent && user.byt && user.byt !== '-' && (
                    <ProfileCard title="Характеристика от тренера">
                        <InputField
                            label="Профессиональная характеристика"
                            value={user.byt}
                            onChange={handleInputChange('byt')}
                            disabled={isViewOnly}
                            type="textarea"
                            placeholder="Опишите характеристику ученицы..."
                        />
                    </ProfileCard>
                )}

                {/* Статус редактирования */}
                <div style={{
                    textAlign: 'center',
                    padding: '16px',
                    color: '#6b7280',
                    fontSize: '14px'
                }}>
                    {isViewOnly ? (
                        'Режим просмотра'
                    ) : (
                        'Режим редактирования'
                    )}
                </div>
            </div>

            <Navbar usertype={Prole} fixedT={!isStudent ? user.public_key : ''} />
        </div>
    );
}